import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const TableOrStackedBarChart = () => {
  const dispatch = useDispatch();
  const { data_table: { rows = [], cols = [] } = {}, options } = useSelector(
    (state) => state.productSales.chartData
  );
  const tableView = useSelector((state) => state.productSales.selectedFilters.table_view);
  const currencySymbol = useSelector((state) => state.productSales.currentUser.currencySymbol);

  return (
    <GoogleChart
      chartName="sales_revenue_product_sales_chart"
      width="1350px"
      height={400}
      isTableView={tableView}
      rows={rows}
      columns={cols}
      options={options}
      enableEventListeners
      currencySymbol={currencySymbol}
      switchView={(data) => dispatch(actionCreators.updateTableView(data))}
    />
  );
};

export default TableOrStackedBarChart;
